export default __webpack_public_path__ + "static/media/headphone.2da7ae68.svg";